export default {
  firebaseUser: null,
  firebaseIdToken: null,
  me: null,
  loading: false,
  authRedirectError: null,
  authRedirectDebug: null
}
